export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert, UsersResource) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.searchText = '';
    }

    search() {

        this.spAlert = null;
        this.selectedCompanyUser = null;
        this.isSearching = true;

        this.UsersResource
            .getCompanyUserForSaaspassUser(this.companyId,this.searchText)
            .then((companyUser) => this.selectedCompanyUser = companyUser)
            .catch((response) => {
                if (response.status === 404) {
                    this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            })
            .finally(() => this.isSearching = false);
    }

    verify() {
        this.isVerifying = true;
        this.AccountsResource
            .verifyAccount(this.companyId, this.account.id, this.selectedCompanyUser)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.verify.success'))
            .finally(() => this.isVerifying = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/verify/verify-account-owner.controller.js